import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import DeleteButton from '../DeleteButton';
import Select from 'react-select';

class EditAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // email: 'aerrity@gmail.com',
      // password: 'testing',
      adminId: null,
      name: '',
      email: '',
      password: '',
      incorrect: false,
      error: 'name, email, or password incorrect. Please try again.',
      loading: true,
      loadError: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.redirect = this.redirect.bind(this);

  }

  loadData() {
    this.setState({ loading: true });

    let adminId = this.props.match.params.id;
    this.setState({ adminId });

    const headers = {
      'Content-Type': 'application/json'
    };

    return axios
      .get(`/api/editor/${adminId}`, headers)
      .then(response => {
        let data = response.data.data;
        this.setState({
          name: data.name,
          email: data.email,
          password: data.password,
          loading: false,
          loadError: false
        });


      })
      .catch(function(error) {
        console.log('Request failure: ', error);
        this.setState({
          loading: false,
          loadError: `${error}`
        });
      });


  }
  componentDidMount() {
    this.loadData();
    this.setState({ incorrect: false });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ incorrect: false });
    // TODO CSRF validation currently disabled in Kernel.php

    const headers = {
      'X-CSRF-TOKEN': window.Laravel.csrfToken,
      'X-Requested-With': 'XMLHttpRequest'
    };

    // user['_token'] = window.Laravel.csrfToken;

    axios
      .put(`/api/editor/${this.state.adminId}`, this.state, headers)
      .then(response => {
        this.props.history.push('/admin/dashboard/admins');
      })
      .catch(err => {
        let errors = Object.values(err.response.data.data);
        this.setState({ incorrect: true, error: errors });
      });

    return false;
  }

  redirect(){
    this.props.history.push('/admin/dashboard/admins');
  }

  render() {

    const { loading, loadError, name, email, password, error, incorrect, adminId } = this.state;

    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: '#ffffff',
        color: '#8d95a6',
        height: '58px',
        fontSize: '16px',
        paddingLeft: '15px',
        width: '100%',
        marginBottom: '10px',
        outline: 'none',
        border: 'none'
      })
    };

    if (loadError) {
      return "ERROR";
    }
    else if (loading) {
      return "LOADING..."
    }
    else {
      return (
        <section className="contact-wrapper">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="contact_form">
                  <h3 className="title">Edit Admin
                  <DeleteButton route='editor' id={adminId} label='Delete Admin' redirect={this.redirect} />
                  </h3>



                  <div id="login">
                    <div id="message" />
                    <form
                      method="post"
                      action=""
                      name="loginform"
                      id="loginform"
                      onSubmit={this.handleSubmit}>
                      <input
                        type="hidden"
                        name="csrf-token"
                        value={window.Laravel.csrfToken}
                      />

<div className="row">
                      <div className="col-12  form-group">
                        <label>Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          id="name"
                          required
                          value={this.state.name}
                          onChange={this.handleInputChange}
                        />
                      </div>

                      <div className="col-12  form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="example@example.com"
                          name="email"
                          id="email"
                          required
                          value={this.state.email}
                          onChange={this.handleInputChange}
                        />

                      </div>


                      <div className="col-12  form-group">
                        <label>Role</label>

                        <Select
                          styles={customStyles}
                          value={{ value: 'editor', label: 'Editor' }}
                          isDisabled={true}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={false}
                          options={[
                            { value: 'editor', label: 'Editor' }
                          ]}
                        />
                      </div>


                      <div className="col-12  form-group">
                      <label>Password</label>
                        <input
                          type="password"
                          className="form-control"
                          name="password"
                          id="password"
                          required
                          value={this.state.password}
                          onChange={this.handleInputChange}
                        />

                    </div>


                        {/* <div className="col-12  form-group">
                              <div className="row">
                                <div className="col-12  col-sm-12 col-md-6 form-group">
                                  <label>Remember me</label>
                                </div>
                                <div className="col-12  col-sm-12 col-md-2 form-group">
                                  <input
                                    type="checkbox"
                                    name="remember"
                                    value={this.state.rememberMe}
                                    onChange={this.handleInputChange}
                                  />
                                </div>
                              </div>
                            </div> */}
                        <div className="col-12 form-group" style={{'visibility': incorrect ? 'visible' : 'hidden'}}>
                          <label style={{'color': 'red'}}>{error}</label>
                        </div>

                        <div className="submit-btn mt-0">
                          <input
                            className="btn btn-primary"
                            value="Submit"
                            type="submit"
                            name="submit"
                            id="submit"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
  }
}


export default withRouter(EditAdmin);
